import useSWR from 'swr'

import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'
import { useMemo } from 'react'

export type EventsResponse = {
  event_id: number
  event_name: string
  event_date: string
  pdv_serial: string
  event_place: string
  imgUrl: string
}

export interface useEventPDVsProps {
  courtesyEvents: EventsResponse
  courtesyEventsLoading: boolean
  courtesyEventsError: AxiosError
}

export const useEventsWithCourtesy = (): useEventPDVsProps => {
  const url = `/producer/app/v2/pdv/courtesies/events`

  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)

  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      courtesyEvents: nestedData,
      courtesyEventsLoading: isLoading,
      courtesyEventsError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
